<router-outlet></router-outlet>

<div id="fileManagerContent"></div>
<div id="settingsPanelContent"></div>
